import { jsxs, jsx } from "react/jsx-runtime";
import { emitLinkClickEvent } from "../../../utils/tracking.js";
import { useFooterContext } from "../Footer.js";
import styles from "./AlphabetNav.module.scss.js";
function AlphabetNav() {
  const context = useFooterContext();
  return /* @__PURE__ */ jsxs("div", { className: styles.root, children: [
    /* @__PURE__ */ jsx("h2", { className: styles.heading, children: "Apps by title" }),
    /* @__PURE__ */ jsx("nav", { children: /* @__PURE__ */ jsx("ul", { className: styles.list, children: ["0-9", ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"].map((letter) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
      "a",
      {
        className: styles.link,
        href: context.resolveURL(`/find-apps/${letter.toLowerCase()}`),
        "aria-label": `Apps beginning with ${letter}`,
        onClick: (e) => {
          emitLinkClickEvent(e, {
            interaction_name: "footer_alphabet_nav_link_click"
          });
        },
        children: letter
      }
    ) }, letter)) }) })
  ] });
}
export {
  AlphabetNav
};
